import React from "react";
import { useSelector } from "react-redux";
import { Autocomplete, TextField } from "@mui/material";
import { useTableDispenserUserConfig } from "./hooks";

export const DispenserUserSelectStation = (props) => {
  const { size = 'small' } = props;
  const { handleChangeStation } = useTableDispenserUserConfig();
  const { stationsList } = useSelector(({ companies }) => companies);
  const { station, dispenserUserSelected } = useSelector(({ dispenserUser }) => dispenserUser);
  
  return (
    <Autocomplete
      id="combo-box-demo"
      options={stationsList}
      value={station}
      filterSelectedOptions
      disabled={dispenserUserSelected?.id} 
      getOptionLabel={(option) => option.label ? option.label : option.name}
      renderInput={(params) => (
        <TextField
          {...params}
          name="stations"
          label="Planta"
          variant="outlined"
          size={size}
          disabled={dispenserUserSelected?.id} 
        />
      )}
      fullWidth
      onChange={(e, v) => handleChangeStation(e, v)}
      noOptionsText="No se encuentra la planta"
    />
  );
};
